import { useState, useEffect } from "react";

import "./Navbar.css";
import Logo from "../../assets/img/logo_net_viet.png";

const Navbar = () => {
    const [currentNav, setCurrentNav] = useState("accueil")
    const [hamburger, setHamburger] = useState(null)

    function changeHam(e) {
        setHamburger(!hamburger)

        if (!hamburger) {
            document.getElementById("NavBar").classList.add("blackAnimation")
            document.getElementById("underline").classList.add("underline")
        } else {
            document.getElementById("NavBar").classList.remove("blackAnimation")
            document.getElementById("underline").classList.remove("underline")
        }
    }

    /* window.addEventListener('scroll', (e) => {
        if (window.pageYOffset === 0 && currentNav) {
            document.getElementById("NavBar").classList.add("top")
            document.getElementById("Logo").classList.add("logoTop")
        } else {
            document.getElementById("NavBar").classList.remove("top")
        }
    }) */

    useEffect(() => {
        if(window.location.pathname === "/"){
            setCurrentNav("accueil")
        }else{
            setCurrentNav(window.location.pathname.substring(1))
        }
        var myListA = document.getElementsByTagName("a");
        var i = 0;
        for (i = 0; i < myListA.length; i++) {
            //it does work
            myListA[i].classList.remove("activeNav")
        }
        document.getElementById(currentNav).className += "activeNav"

        /* if (window.pageYOffset === 0 && currentNav) {
            if (currentNav === "carte") {
                document.getElementById("NavBar").classList.remove("top")
            } else {
                document.getElementById("NavBar").classList.add("top")
                document.getElementById("Logo").classList.add("logoTop")
            }
        } else {
            document.getElementById("NavBar").classList.remove("top")
        } */

    }, [currentNav,setCurrentNav]);

    return (
        <nav id="NavBar" className="navbar">
            <div className={hamburger ? "containerHamburger change" : "containerHamburger"} onClick={changeHam}>
                <div className="bar1"></div>
                <div className="bar2"></div>
                <div className="bar3"></div>
            </div>
            <div id="underline"></div>
            <a href="/accueil"><img src={Logo} alt="Logo_Net_Viet" id="Logo" className="logo logoTop" /></a>
            <ul id="NavBar_list" className={hamburger ? "navActive slideIn" : "slideOut"}>
                <li><a id="accueil" href="/accueil">Accueil</a></li>
                <li><a id="carte" href="/carte">Carte</a></li>
                <li><a id="commander" href="https://www.ubereats.com/fr/store/net-viet/v4u1WjG3SuyYOS1dJVQrRg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMjIlMjBSdWUlMjBKYWNxdWVzJTIwRGFndWVycmUlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKNWJaUmYyMWo1a2NSbFYtVGVNamxIR0klMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNDguODg5MzcyJTJDJTIybG9uZ2l0dWRlJTIyJTNBMi4xNzAwNiU3RA%3D%3D" target="_blank" rel="noopener noreferrer">Commander</a></li>
                <li class="navbar_information"><a href="https://goo.gl/maps/6ayY7oX2rSNvwuQE7" rel="noreferrer" target="_blank"><h4>1 rue Jacques Daguerre, Rueil-Malmaison 92500</h4></a></li>
                <li class="navbar_information"><a href="tel:0617496881"><h4>06 17 49 68 81</h4></a></li>
            </ul>
        </nav>
    );
};

export default Navbar;